import { NgModule } from '@angular/core';
import { CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';
import {ModuleExecutorApiService} from './moduleexecutor-api.service';

@NgModule({
  imports: [
    ConfigManagerModule
  ],
  providers: [
    ModuleExecutorApiService,
    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: { configFileUrl: './assets/config.json'}},
  ]
})
export class SdkModuleExecutorModule { }
